import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

const HideIconRaw = ({
  style,
  stroke,
  className,
}: {
  style?: StyleProp<ViewStyle>;
  stroke?: string;
  className?: string;
}) => {
  return (
    <Svg width={24} height={24} viewBox="0 0 25 25" fill="none" style={style}>
      <Path
        d="M3.57626 3.5L21.5763 21.5"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <Path
        d="M14.3108 14.2351C14.0861 14.4763 13.8151 14.6697 13.514 14.8038C13.2129 14.938 12.8879 15.0101 12.5583 15.0159C12.2288 15.0218 11.9014 14.9611 11.5958 14.8377C11.2901 14.7142 11.0125 14.5305 10.7794 14.2974C10.5463 14.0643 10.3626 13.7867 10.2391 13.4811C10.1157 13.1754 10.0551 12.8481 10.0609 12.5185C10.0667 12.1889 10.1388 11.8639 10.273 11.5628C10.4071 11.2617 10.6006 10.9907 10.8417 10.766M17.4363 17.3606C16.0377 18.4266 14.3346 19.0173 12.5763 19.046C6.84899 19.046 3.57626 12.5006 3.57626 12.5006C4.59399 10.6039 6.00556 8.94687 7.71626 7.64055L17.4363 17.3606ZM10.8581 6.15146C11.4213 6.01964 11.9979 5.95374 12.5763 5.9551C18.3035 5.9551 21.5763 12.5006 21.5763 12.5006C21.0796 13.4297 20.4873 14.3044 19.809 15.1106L10.8581 6.15146Z"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export const HideIcon = nativewindWrapSvg(HideIconRaw);
